import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import React, { useContext, useState } from 'react';
import context from '../context';
import Banner from './Banner';
import FormVitrine from '../vitrines/FormVitrine';

const VitrineComBanner: React.FC = () => {
  const { pageGroup } = useContext(context);
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Tabs index={tabIndex} onChange={index => setTabIndex(index)}>
      <TabList>
        <Tab>Dados</Tab>
        <Tab isDisabled={!pageGroup}>Banner</Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <FormVitrine onCreated={() => setTabIndex(1)} />
        </TabPanel>
        <TabPanel>
          <Banner />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default VitrineComBanner;
